<template>
  <div class="uk-flex-between uk-flex">
    <div>
      <a
        :uk-tooltip="approveTooltip"
        class="annotation-approval-button uk-margin-small-right uk-text-secondary"
        :class="{
          'uk-text-success': isApproved,
          faded: isDisapproved,
          'disable-gray': editMode,
        }"
        @click="onApprove"
      >
        <span uk-icon="check"></span>
      </a>
    </div>

    <div v-if="editMode">
      <button
        :uk-tooltip="'Restore the original annotation.'"
        class="uk-border-rounded uk-button-primary uk-flex-end edit-btn-approve rotate-icon"
        uk-icon="refresh"
        @click="onRestore"
      ></button>
      <button
        :uk-tooltip="'Save your changes'"
        class="uk-border-rounded uk-button-primary uk-flex-end edit-btn-approve"
        uk-icon="check"
        @click="onSave"
      ></button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

// Props
interface Props {
  isApproved?: boolean;
  isDisapproved?: boolean;
  editMode?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  isApproved: false,
  isDisapproved: false,
  editMode: false,
});

// Emits
const emit = defineEmits(['approve', 'restore', 'save']);

// Computed
const approveTooltip = computed(() => {
  return props.isApproved ? 'Press to reverse your decision' : 'Include this annotation';
});

// Methods
const onApprove = () => emit('approve');
const onRestore = () => emit('restore');
const onSave = () => emit('save');
</script>

<style scoped lang="scss">
.annotation-approval-button {
  &.faded {
    opacity: 0.25;
  }
}

.edit-btn-approve {
  padding: 2px 6px;
  margin-right: 7px;
}

.rotate-icon {
  transform: rotateY(180deg);
}

.disable-gray {
  pointer-events: none;
  opacity: 0.3;
}
</style>
